import { render, staticRenderFns } from "./Alertbox.vue?vue&type=template&id=1c8c861d&"
import script from "./Alertbox.vue?vue&type=script&lang=js&"
export * from "./Alertbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports